var styleDataHash = "ae69ff6c";
const injectCss = (() => {
  var css = `@charset "UTF-8";.A5Us6,.ReactModalPortal,._09-Jn,.glob_fontElementMap,button{font-family:var(--ricos-font-family,unset)}.eONe-{display:flex}.q0iyx:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.lR0D9,.q0iyx:hover{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}.lR0D9{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.W1dQ5 .lR0D9{box-shadow:none!important}.r4Wrc{cursor:move;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.r4Wrc.UJk6c{pointer-events:none}.JYWgm ::selection{background:transparent}.g2Rv4{display:none}._09-Jn{position:relative}.SDivn{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{direction:ltr;font-weight:300}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.ibx-X{color:#333;text-decoration:none}.lOy2T{display:block}.rT4AU{position:relative}.QZiN8{margin-left:-20px;margin-right:-20px;overflow-x:auto;overflow-y:hidden}.QZiN8.om7i6::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}.QZiN8._7eXQa::-webkit-scrollbar-thumb{background-color:transparent}._23ZNx{max-width:max-content!important;min-width:100%}.QZiN8::-webkit-scrollbar{-webkit-appearance:none}.QZiN8::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.QZiN8::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "fontElementMap": "A5Us6",
  "pluginContainer": "_09-Jn",
  "flex": "eONe-",
  "isFocusable": "q0iyx",
  "hasFocus": "lR0D9",
  "dragImageView": "W1dQ5",
  "overlay": "r4Wrc",
  "noPointerEventsOnFocus": "UJk6c",
  "hideTextSelection": "JYWgm",
  "hidden": "g2Rv4",
  "pluginContainerMobile": "SDivn",
  "isImage": "ibx-X",
  "anchor": "lOy2T",
  "horizontalScrollbarWrapper": "rT4AU",
  "pluginWithHorizontalScrollbar": "QZiN8",
  "show": "om7i6",
  "hide": "_7eXQa",
  "horizontalScrollbar": "_23ZNx"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
